module.exports = __webpack_public_path__ + "static/media/offline_playback.3bd12dd5.svg";